import {
    AUTHENTICATION_PATHS,
    ERROR_PATHS,
    ROOT_PATHS
} from '~core/constants/paths.constants';

export const ROOT_URLS = {
    home: `/${ROOT_PATHS.home}`,
};

export const AUTH_URLS = {
    logIn: `/${AUTHENTICATION_PATHS.base}/${AUTHENTICATION_PATHS.logIn}`

};

export const ERROR_URLS = {
    notFound: `/${ERROR_PATHS.base}/${ERROR_PATHS.notFound}`,
};